import { setCookie, getCookie, deleteCookie } from 'cookies-next'
import { SessionCookieKeyNames } from './session.types'

/**
 * This module makes it seasy to get, set, and delete session cookies from a
 * typed list of keys. Uses Generics to typeset the return value.
 */

export const getSessionCookie = <T>(key: SessionCookieKeyNames): T | undefined => {
  try {
    const value = getCookie(key)

    if (typeof value === 'string') {
      return JSON.parse(value) as T
    }

    return undefined
  } catch (error) {
    console.error(`Unable to get ${key} from cookie`)
    throw new Error(`Unable to get ${key} from cookie`) // need to catch this in an error boundary
  }
}

export const setSessionCookie = <T>(key: SessionCookieKeyNames, value: T) => {
  try {
    setCookie(key, JSON.stringify(value))
  } catch (error) {
    console.error(`Unable to set ${key} to sessionStorage`)
    throw new Error(`Unable to set ${key} to sessionStorage`) // need to catch this in an error boundary
  }
}

export const deleteSessionCookie = (key: SessionCookieKeyNames) => {
  deleteCookie(key)
}
